import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Globe, CheckCircle2, XCircle, Copy } from "lucide-react";
import { toast } from "sonner";

export default function Subdomains() {
    const [subs, setSubs] = useState([]);

    useEffect(() => {
        api.get("/subdomains").then(({ data }) => setSubs(data));
    }, []);

    const copy = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Copied.");
    };

    return (
        <div className="space-y-8">
            <div className="fade-up">
                <div className="text-[10px] uppercase tracking-[0.35em] text-muted-foreground">Multi-Tenant Manager</div>
                <h1 className="font-heading text-4xl sm:text-5xl mt-1 tracking-tighter">Subdomains</h1>
                <p className="text-muted-foreground mt-2 max-w-2xl">
                    Every territory spins up its own tenant. One state, one sector, one dedicated front door.
                </p>
            </div>

            {subs.length === 0 ? (
                <div className="glass rounded-2xl p-10 text-center text-muted-foreground">
                    No subdomains provisioned yet. Claim a territory to auto-generate one.
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {subs.map((s) => (
                        <div key={s.id} className="glass rounded-2xl p-6" data-testid={`subdomain-${s.id}`}>
                            <div className="flex items-start justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-md bg-[hsl(40_61%_22%)] flex items-center justify-center text-[hsl(45_85%_68%)]">
                                        <Globe size={18} strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{s.state_code} · {s.sector}</div>
                                        <div className="font-mono text-base mt-0.5">{s.subdomain}</div>
                                    </div>
                                </div>
                                {s.status === "provisioned" ? (
                                    <span className="text-[10px] uppercase tracking-wider text-[hsl(45_85%_68%)] inline-flex items-center gap-1">
                                        <CheckCircle2 size={12} /> provisioned
                                    </span>
                                ) : (
                                    <span className="text-[10px] uppercase tracking-wider text-[hsl(350_75%_65%)] inline-flex items-center gap-1">
                                        <XCircle size={12} /> {s.status}
                                    </span>
                                )}
                            </div>

                            <div className="mt-4 flex items-center gap-2">
                                <button
                                    onClick={() => copy(`https://${s.subdomain}`)}
                                    data-testid={`copy-subdomain-${s.id}`}
                                    className="text-xs px-3 py-1.5 rounded-md border border-[hsl(40_50%_35%/0.35)] hover:bg-[hsl(151_55%_15%)] transition-colors inline-flex items-center gap-1.5"
                                >
                                    <Copy size={12} /> Copy URL
                                </button>
                                <a
                                    href={`https://${s.subdomain}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-xs px-3 py-1.5 rounded-md bg-[hsl(40_61%_53%)] text-[hsl(40_20%_10%)] font-semibold hover:bg-[hsl(45_75%_62%)] transition-colors"
                                >
                                    Visit
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
